import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { resetStyles } from '../../utils/ThemeUtil.js';
import { customElement } from '../../utils/WebComponentsUtil.js';
import styles from './styles.js';
let WuiLoadingThumbnail = class WuiLoadingThumbnail extends LitElement {
  constructor() {
    super(...arguments);
    this.radius = 36;
  }
  render() {
    return this.svgLoaderTemplate();
  }
  svgLoaderTemplate() {
    const radius = this.radius > 50 ? 50 : this.radius;
    const standardValue = 36;
    const radiusFactor = standardValue - radius;
    const dashArrayStart = 116 + radiusFactor;
    const dashArrayEnd = 245 + radiusFactor;
    const dashOffset = 360 + radiusFactor * 1.75;
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <svg viewBox=\"0 0 110 110\" width=\"110\" height=\"110\">\n        <rect\n          x=\"2\"\n          y=\"2\"\n          width=\"106\"\n          height=\"106\"\n          rx=", "\n          stroke-dasharray=\"", " ", "\"\n          stroke-dashoffset=", "\n        />\n      </svg>\n    "])), radius, dashArrayStart, dashArrayEnd, dashOffset);
  }
};
WuiLoadingThumbnail.styles = [resetStyles, styles];
__decorate([property({
  type: Number
})], WuiLoadingThumbnail.prototype, "radius", void 0);
WuiLoadingThumbnail = __decorate([customElement('wui-loading-thumbnail')], WuiLoadingThumbnail);
export { WuiLoadingThumbnail };
//# sourceMappingURL=index.js.map